import { Outlet } from "react-router-dom";
import { StoreHeader } from "./StoreHeader";
import { StoreFooter } from "./StoreFooter";
import { CartDrawer } from "./CartDrawer";
import { SearchFab } from "./SearchFab";
import { MessagesFab } from "./MessagesFab";
import { PWAInstallPrompt } from "@/components/PWAInstallPrompt";

export const StoreLayout = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <StoreHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <StoreFooter />
      <CartDrawer />
      <SearchFab />
      <MessagesFab />
      <PWAInstallPrompt />
    </div>
  );
};
